<!-- MAIN CONTAINER -->
<div class="d-flex flex-column vh-100">

    <!-- FIXED SPACE FOR MAIN NAV BAR-->
    <div class="container">
        <div class="row my-3 py-3">
        </div>
    </div>

    <!-- FORM HEADER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-4">
            <div class="row">

                <!-- FORM TITLE -->
                <div class="col-12 col-lg-5">
                    <h4 class="card-title lg-3 mb-lg-1 text-body-secondary">
                        <i class="bi bi-person-rolodex me-2 fs-1 text-primary"></i>Cliente
                    </h4>
                </div>

                <!-- FUNCTIONS BUTTONS -->
                <div class="col ms-2 m-lg-0 d-lg-flex justify-content-lg-end align-items-lg-end">
                    <div *ngIf="opE === '1'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(false, true)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
              <i class="bi-pencil-square me-2"></i>Editar
            </button>
                    </div>
                    <div *ngIf="opE === '1' && rol ==='Administrador'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0"><button (click)="eliminar()" class="INN-function-button link-opacity-50-hover text-decoration-none link-danger fs-6">
            <i class="bi-trash3 me-2"></i>Eliminar
          </button>
                    </div>
                    <div *ngIf="opE === '2'" class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="validaFormulario(true, false)" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
            <i class="bi-save me-2"></i>Guardar
          </button>
                    </div>
                    <div class="col-12 col-sm-auto ms-0 ms-lg-3 mt-2 mt-lg-0">
                        <button (click)="cancelar()" class="link-opacity-50-hover text-decoration-none link-secondary fs-6 no-mostrar-boton">
            <i class="bi-x-circle me-2"></i>Cancelar
          </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- FORM CONTENT -->
    <div class="container pe-6">
        <div class="card card-body INN-form justify-content-center mt-2">
            <form class="needs-validation" novalidate>
                <div class="row g-3">

                    <!-- FIELD -->
                    <div class="col-md-12">
                        <label for="Field" class="form-label">Nombre Comercial</label>
                        <input type="text" class="form-control" name="nombre" id="nombre" [(ngModel)]="cliente.nombre" #nombre="ngModel" [ngClass]="{'is-invalid': nombre.invalid && (nombre.dirty || nombre.touched)}" (ngModelChange)="mostrarMensaje(nombre, 'nombre')" (blur)="mostrarMensaje(nombre, 'nombre')"
                            required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageNombre">
                            {{mensajeValidacionNombre}}
                        </p>
                    </div>

                    <!-- FIELD -->
                    <div class="col-md-8">
                        <label for="Field" class="form-label">Razón Social</label>
                        <input type="text" class="form-control" name="razon_social" id="razon_social" [(ngModel)]="cliente.razon_social" #razonSocial="ngModel" [ngClass]="{'is-invalid': razonSocial.invalid && (razonSocial.dirty || razonSocial.touched)}" (ngModelChange)="mostrarMensaje(razonSocial, 'razonSocial')"
                            (blur)="mostrarMensaje(razonSocial, 'razonSocial')" required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageRazon">
                            {{mensajeValidacionRazon}}
                        </p>
                    </div>

                    <!-- FIELD -->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">RFC</label>
                        <input type="text" class="form-control" name="rfc" id="rfc" [(ngModel)]="cliente.rfc" #rfc="ngModel" [ngClass]="{'is-invalid': rfc.invalid && (rfc.dirty || rfc.touched)}" (ngModelChange)="mostrarMensaje(rfc, 'rfc')" (blur)="mostrarMensaje(rfc, 'rfc')"
                            required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageRFC">
                            {{mensajeValidacionRFC}}
                        </p>
                    </div>

                    <!-- BAR -->
                    <hr class="mt-4 mb-0">

                    <!-- FIELD -->
                    <div class="col-md-12">
                        <label for="Field" class="form-label">Dirección</label>
                        <input type="text" class="form-control" name="direccion" id="direccion" [(ngModel)]="cliente.direccion" #direccion="ngModel" [ngClass]="{'is-invalid': direccion.invalid && (direccion.dirty || direccion.touched)}" (ngModelChange)="mostrarMensaje(direccion, 'direccion')"
                            (blur)="mostrarMensaje(direccion, 'direccion')" required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageDic">
                            {{mensajeValidacionDic}}
                        </p>
                    </div>

                    <!-- FIELD -->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">C.P.</label>
                        <input type="text" class="form-control" name="cp" id="cp" [(ngModel)]="cliente.cp" #cp="ngModel" [ngClass]="{'is-invalid': cp.invalid && (cp.dirty || cp.touched)}" (ngModelChange)="mostrarMensaje(cp, 'cp')" (blur)="mostrarMensaje(cp, 'cp')" required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageCP">
                            {{mensajeValidacionCP}}
                        </p>
                    </div>

                    <!-- FIELD -->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">Ciudad</label>
                        <input type="text" class="form-control" name="ciudad" id="ciudad" [(ngModel)]="cliente.ciudad" #ciudad="ngModel" [ngClass]="{'is-invalid': ciudad.invalid && (ciudad.dirty || ciudad.touched)}" (ngModelChange)="mostrarMensaje(ciudad, 'ciudad')" (blur)="mostrarMensaje(ciudad, 'ciudad')"
                            required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageCD">
                            {{mensajeValidacionCD}}
                        </p>
                    </div>

                    <!-- FIELD -->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">Estado</label>
                        <input type="text" class="form-control" name="estado" id="estado" [(ngModel)]="cliente.estado" #estado="ngModel" [ngClass]="{'is-invalid': estado.invalid && (estado.dirty || estado.touched)}" (ngModelChange)="mostrarMensaje(estado, 'estado')" (blur)="mostrarMensaje(estado, 'estado')"
                            required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageEst">
                            {{mensajeValidacionEst}}
                        </p>
                    </div>

                    <!-- BAR -->
                    <hr class="mt-4 mb-0">

                    <!-- FIELD -->
                    <div class="col-md-4">
                        <label for="Field" class="form-label">Teléfono</label>
                        <input type="tel" class="form-control" name="telefono" id="telefono" [(ngModel)]="cliente.telefono" #telefono="ngModel" [ngClass]="{'is-invalid': telefono.invalid && (telefono.dirty || telefono.touched)}" (ngModelChange)="mostrarMensaje(telefono, 'telefono')"
                            (blur)="mostrarMensaje(telefono, 'telefono')" required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageTel">
                            {{mensajeValidacionTel}}
                        </p>
                    </div>

                    <div class="col-md-8">
                        <label for="Field" class="form-label">Correo</label>
                        <input type="tel" class="form-control" name="correo" id="correo" [(ngModel)]="cliente.correo" #correo="ngModel" [ngClass]="{'is-invalid': correo.invalid && (correo.dirty || correo.touched)}" (ngModelChange)="mostrarMensaje(correo, 'correo')" (blur)="mostrarMensaje(correo, 'correo')"
                            required>
                        <p class="invalid-feedback" *ngIf="showErrorMessageCor">
                            {{mensajeValidacionCor}}
                        </p>
                    </div>

                    <!-- SPACER -->
                    <div class="col-md-6 m-0 p-0">
                    </div>

                </div>
            </form>
        </div>
    </div>

    <!-- FORM FOOTER -->
    <div class="container">
        <div class="card card-body INN-form justify-content-center mt-2 mb-4">
            <div class="row">

                <!-- FORM FOOTER CONTENT -->

            </div>
        </div>
    </div>

    <!-- FORM FOOTER -->
    <div class="container">
        <div class="row mb-4 pb-4">
        </div>
    </div>


</div>
<!-- END MAIN CONTAINER -->